import { motion } from "framer-motion";
import { IMAGES } from "@/lib/content";

const STEPS = [
  { n: "01", title: "Book & Get a Quote", text: "Send your details online or call us. We give you a clear, honest quote — no surprises." },
  { n: "02", title: "Pre-Treat & Inspect", text: "We inspect fibres and stains, then pre-treat high-traffic areas and spots for the best result." },
  { n: "03", title: "Deep Steam Clean", text: "Powerful portable hot-water extraction flushes out dirt, allergens and odours from deep in the pile." },
  { n: "04", title: "Fast Dry & Walkthrough", text: "Powerful extraction leaves carpets nearly dry. We walk through with you to make sure it's perfect." },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative py-20 md:py-32 bg-[#0F172A] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img src={IMAGES.action} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0F172A]/80" />
      </div>
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="label-caps mb-4" style={{ color: "#94A3B8" }}>How It Works</div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">
            A proven 4-step process for a flawless clean.
          </h2>
        </div>
        <div className="grid md:grid-cols-4 gap-8">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
            >
              <div className="font-display text-5xl font-extrabold text-[#2B4BB8]">{s.n}</div>
              <div className="h-px bg-white/20 my-5" />
              <h3 className="font-display text-lg font-bold">{s.title}</h3>
              <p className="mt-2 text-sm text-white/70 leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
